// import React from 'react';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axios";
import '../App.css';
// import EventView from '../src/img/web_image.png';
import seriti_loader from '../Images/logo/Seriti BW - system logo.png';
import Loader from "../Components/Loader"

const MaintenanceMode = () => {
  // console.log("rjfjdk");
  // const navigate = useNavigate();
  const [ErrorListData, setErrorListData] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    axios.get("list_system_error")
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          // console.log(response.data);
          setErrorListData(response.data);
        }
      })
      .catch(() => {
        console.log('error');
      });
  }, []);

  const download_database = (flag) => {
    //alert(flag);
    setLoader(true);
    const payload = {
        command: flag,
    };
    //console.log(payload);
    axios.post("download_database", payload)
        .then((response) => {
            //console.log(response);
            if (response.status === 200) {
              const link = document.createElement('a');
              link.href = response.data.download_path;
              link.setAttribute('download', response.data.zip || 'backup.zip');
              link.setAttribute('target', '_blank'); // open in new tab if necessary
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setLoader(false);
            }
            setLoader(false);
        })
        .catch(() => {
            // console.log('error');
            setLoader(false);
        });
  }
  

  return (
    <>
    {loader ? <Loader /> : null}
    <div>
      <div className="row w-100 px-4" >
        <div className="col-sm-12 d-flex align-items-center justify-content-center flex-column" >
          <img className="maintenance-ytcr-logo my-1" src={seriti_loader} alt="Seriti" /> <br /> <br />
          
          <div style={{display: 'flex'}}>
              <input type="button" name="command" value="Download DB" onClick={() => { download_database('db') }} /> &nbsp;&nbsp;
              {/* <input type="button" name="command" value="Download Backend" onClick={() => { download_database('backend') }} /> */}
          </div>
         
          <br />

          <table  cellPadding={2} cellSpacing={0} width="100%" bgcolor="#ffffff" style={{border: '1px solid #ccc9c9'}}  >
            <tbody>

              <tr>
                <th style={{border: '1px solid #ccc9c9'}}>Transaction No</th>
                <th style={{border: '1px solid #ccc9c9'}}>File Name</th>
                <th style={{border: '1px solid #ccc9c9'}}>Line No</th>
                <th style={{border: '1px solid #ccc9c9'}}>Error Message</th>
                <th style={{border: '1px solid #ccc9c9'}}>Exception</th>
                <th style={{border: '1px solid #ccc9c9'}}>Date/Time</th>
              </tr>
             
              {ErrorListData.length > 0 ?
                ErrorListData.map((item, index) => {
                  return (
                    <tr key={index} className="caption">
                      <td style={{border: '1px solid #ccc9c9'}}>{item.transaction_no}</td>
                      <td style={{textTransform: "none" , fontSize: 12, border: '1px solid #ccc9c9'}}>{item.file_name}</td>
                      <td style={{textTransform: "none" , fontSize: 12, border: '1px solid #ccc9c9'}}>{item.line_no}</td>
                      <td style={{textTransform: "none" , fontSize: 12, border: '1px solid #ccc9c9'}}>{item.error_message}</td>
                      <td style={{textTransform: "none" , fontSize: 12, border: '1px solid #ccc9c9'}}>{item.exception}</td>
                      <td style={{textTransform: "none" , fontSize: 12, border: '1px solid #ccc9c9'}}>{item.create_date}</td>
                    </tr>
                  );
                })
                : null}
            </tbody>
          </table>

        </div>
       </div>
      </div>
    </>
  );
};

export default MaintenanceMode;